import type { OnInit} from '@angular/core';
import {Component, ElementRef, Input, Renderer2, ViewChild} from '@angular/core';
import {HttpClient} from "@angular/common/http";

declare let window;

@Component({
  selector: 'app-radiant-player',
  templateUrl: './radiant-player.component.html',
  styleUrls: ['./radiant-player.component.scss']
})
export class RadiantPlayerComponent implements OnInit {
  @Input() mediaId: string;
  @ViewChild('scriptElement', {static: true}) scriptElement: ElementRef;
  @ViewChild('playerElement', {static: true}) playerElement: ElementRef;

  media: IPlaylist;

  constructor(private http: HttpClient, private renderer2: Renderer2) {
  }

  ngOnInit() {
    this.getVideoInfo(this.mediaId);
  }


  private getVideoInfo(mediaId: string) {
    this.http.get(`https://markenfunk.tv/moho/video/${mediaId}/rad`).subscribe(
      (response: IPlaylistResponse) => {
        this.media = response.playlist[0];
        const script = this.renderer2.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://cdn.radiantmediatechs.com/rmp/5.5.1/js/rmp.min.js';

        this.renderer2.appendChild(this.scriptElement.nativeElement, script);

        const src = {
          hls: this.media.bitrates.hls
        };

        // Player settings
        const settings = {
          licenseKey: 'bGlmYXdod2RwbkAxNTIyOTk2',
          src: src,
          width: 930,
          height: 525,
          skin: 's3',
          poster: this.media.poster,
          skinBackgroundColor: 'ffffff',
          skinButtonColor: 'ffffff',
          skinAccentColor: '018e6b',

          // Google Analytics settings
          gaTrackingId: 'UA-47081044-46',
          gaCategory: 'video.tt.com',
          gaLabel: this.media.contentTitle,
          gaEvents: [],
          autoplay: true,

          asyncElementID: 'rmpPlayer',
        };

        // We push player settings to a global rmpAsyncPlayers variable
        if (typeof window.rmpAsyncPlayers === 'undefined') {
          window.rmpAsyncPlayers = [];
        }
        window.rmpAsyncPlayers.push(settings);

        // we wire our events on player container
        const rmpContainer = this.playerElement.nativeElement;
        let rmp = null;

        // To get access to the player instance we need to wait for rmpasyncplayerinstanceavailable event (first event to fire in the API)
        rmpContainer.addEventListener('rmpasyncplayerinstanceavailable', () => {
          // player instance is stored in a global array variable rmpAsyncPlayerInstances
          rmp = window.rmpAsyncPlayerInstances[0];
        });

        rmpContainer.addEventListener('ready', () => {
          settings.gaEvents.push('ready');
        });

        rmpContainer.addEventListener('playing', () => {
          settings.gaEvents.push('playerstart');
          rmp.setBitrate(-1);
        });

        rmpContainer.addEventListener('error', () => {
          console.error('fatal error detected: ', rmp.getErrorData());
          settings.gaEvents.push('error');
        });

        rmpContainer.addEventListener('warning', () => {
          console.error('non-fatal error detected: ', rmp.getErrorData());
          settings.gaEvents.push('warning');
        });
      }
    )
  }
}

interface IPlaylistResponse {
  playlist: IPlaylist[];
}

interface IPlaylist {
  bitrates: {
    hls: string;
    mp4: string[];
  };
  contentDescription: string;
  contentID: string;
  contentTitle: string;
  gaLabel: string;
  poster: string;
  seekBarThumbnailsLoc: string;
}
